import { type Dispatch, type SetStateAction } from "react";
import {
  FETCH_ORGANIZATIONS_ERROR,
  FETCH_ORGANIZATIONS_LOADING,
  FETCH_ORGANIZATIONS_SUCCESS,
} from "./ActionTypes";
import AxiosInstance from "shared/utils/axios";
import { isWorkspaceId } from "shared/utils/workspaceRouting";

export const fetchAllOrgs = async (
  dispatch: Dispatch<SetStateAction<object>>,
  currentOrgId: string | undefined,
  workspaceId: string | undefined,
  signal?: AbortSignal
): Promise<void> => {
  dispatch({ type: FETCH_ORGANIZATIONS_LOADING });
  try {
    if (!isWorkspaceId(workspaceId)) {
      throw new Error(
        "Select a workspace in My Cropwise to load organizations."
      );
    }
    const response = await AxiosInstance.get<Array<{ id: string }>>(
      "/api/orgs",
      {
        params: { workspaceId },
        signal,
      }
    );
    if (signal?.aborted) return;
    if (!Array.isArray(response.data)) {
      throw new TypeError(
        "Invalid organization response for the selected workspace."
      );
    }
    if (currentOrgId && !response.data.some((org) => org.id === currentOrgId)) {
      throw new Error(
        "The selected organization is not available in this workspace."
      );
    }
    dispatch({
      type: FETCH_ORGANIZATIONS_SUCCESS,
      payload: { data: response.data, currentOrgId, workspaceId },
    });
  } catch (error) {
    if (signal?.aborted) return;
    dispatch({ type: FETCH_ORGANIZATIONS_ERROR, error });
  }
};
